(function (scope) {
  'use strict';
  const defaults = { timeZone: 'America/Chicago', interval: 15, leadDays: 1, horizon: 28, blackouts: '' };
  function settings(input = {}) {
    const result = { ...defaults, ...input };
    result.interval = [15, 30, 45, 60].includes(Number(result.interval)) ? Number(result.interval) : 15;
    result.leadDays = Math.max(1, Math.min(7, Number(result.leadDays) || 1));
    result.horizon = Math.max(7, Math.min(56, Number(result.horizon) || 28));
    return result;
  }
  function today(now = new Date(), input = {}) {
    const config = settings(input);
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: config.timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const values = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return `${values.year}-${values.month}-${values.day}`;
  }
  function dateAt(value) { return new Date(`${value}T12:00:00.000Z`); }
  function dates(now = new Date(), input = {}) {
    const config = settings(input);
    const start = dateAt(today(now, config));
    const blocked = new Set(String(config.blackouts || '').split(/[\s,]+/));
    const result = [];
    for (let offset = config.leadDays; offset <= config.horizon; offset++) {
      const date = new Date(start.getTime() + offset * 86400000);
      const value = date.toISOString().slice(0, 10);
      if (date.getUTCDay() < 1 || date.getUTCDay() > 4 || blocked.has(value)) continue;
      result.push({ value, label: new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(date) });
    }
    return result;
  }
  function slots(input = {}) {
    const { interval } = settings(input);
    const result = [];
    for (const [start, end] of [[660, 840], [1020, 1140]]) {
      for (let minute = start; minute <= end; minute += interval) {
        const hour = Math.floor(minute / 60);
        const mm = String(minute % 60).padStart(2, '0');
        result.push({ value: `${String(hour).padStart(2, '0')}:${mm}`, label: `${hour % 12 || 12}:${mm} ${hour < 12 ? 'AM' : 'PM'}` });
      }
    }
    return result;
  }
  function validPickup(date, time, now = new Date(), input = {}) {
    return dates(now, input).some(d => d.value === date) && slots(input).some(s => s.value === time);
  }
  function optionNames(product) { return product.options.map(o => typeof o === 'string' ? o : o.name); }
  function extraValue(allowed = [], chosen = []) { return allowed.filter(label => chosen.includes(label)).join(' + ') || 'None'; }
  function variantFor(product, selected) {
    return product.variants.find(variant => optionNames(product).every((name, i) => variant.options[i] === selected[name]));
  }
  function properties(config, values) {
    const result = {};
    if (config.spice && ['1', '2', '3', '4', '5'].includes(String(values.spice))) result['Spice Level'] = String(values.spice);
    const removals = (config.removals || []).filter(v => (values.removals || []).includes(v));
    if (removals.length) result['Preparation requests'] = removals.join(', ');
    const note = String(values.instructions || '').trim().slice(0, 500);
    if (note) result['Special instructions'] = note;
    return result;
  }
  scope.TLGGCore = { settings, today, dates, slots, validPickup, optionNames, extraValue, variantFor, properties };
})(typeof window === 'undefined' ? globalThis : window);
